<template>
  <div id="app">
   
    <main>
     
      <router-view></router-view>
    </main>
  
  
  </div>
</template>

<script >

export default {
  name: 'App'
}
</script>

<style scoped>

body {
  margin: 0;
}

#app {
 font-family: 'Poppins', sans-serif;
 
}




</style>



// WEBPACK FOOTER //
// src/App.vue